/* eslint-disable */
import * as Types from '../../graphql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const GetMenuItemDocument = gql`
    query GetMenuItem($companyId: Int!, $menuItem: Int, $locale: String) {
  user(companyId: $companyId) {
    id
    company(id: $companyId) {
      id
      menuItems(id: $menuItem) {
        items {
          id
          name(locale: $locale)
          nameOrigin
          types {
            id
            name
            slug
          }
          categories {
            id
            name(locale: $locale)
            nameOrigin
            deleted
          }
          unit {
            id
            name
          }
          portions {
            id
            name(locale: $locale)
            nameOrigin
            volume
            price
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetMenuItemQuery__
 *
 * To run a query within a React component, call `useGetMenuItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMenuItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMenuItemQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      menuItem: // value for 'menuItem'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useGetMenuItemQuery(baseOptions: Apollo.QueryHookOptions<GetMenuItemQuery, GetMenuItemQueryVariables> & ({ variables: GetMenuItemQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMenuItemQuery, GetMenuItemQueryVariables>(GetMenuItemDocument, options);
      }
export function useGetMenuItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMenuItemQuery, GetMenuItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMenuItemQuery, GetMenuItemQueryVariables>(GetMenuItemDocument, options);
        }
export function useGetMenuItemSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMenuItemQuery, GetMenuItemQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMenuItemQuery, GetMenuItemQueryVariables>(GetMenuItemDocument, options);
        }
export type GetMenuItemQueryHookResult = ReturnType<typeof useGetMenuItemQuery>;
export type GetMenuItemLazyQueryHookResult = ReturnType<typeof useGetMenuItemLazyQuery>;
export type GetMenuItemSuspenseQueryHookResult = ReturnType<typeof useGetMenuItemSuspenseQuery>;
export type GetMenuItemQueryResult = Apollo.QueryResult<GetMenuItemQuery, GetMenuItemQueryVariables>;
export const GetCategoriesForMenuItemsFilterDocument = gql`
    query GetCategoriesForMenuItemsFilter($companyId: Int!, $locale: String) {
  user(companyId: $companyId) {
    company(id: $companyId) {
      meMenuCategories(onlyTopLevel: true, deleted: false) {
        id
        name(locale: $locale)
        nameOrigin
        childCategories(deleted: false) {
          id
          name(locale: $locale)
          nameOrigin
        }
      }
    }
  }
}
    `;

/**
 * __useGetCategoriesForMenuItemsFilterQuery__
 *
 * To run a query within a React component, call `useGetCategoriesForMenuItemsFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoriesForMenuItemsFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoriesForMenuItemsFilterQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useGetCategoriesForMenuItemsFilterQuery(baseOptions: Apollo.QueryHookOptions<GetCategoriesForMenuItemsFilterQuery, GetCategoriesForMenuItemsFilterQueryVariables> & ({ variables: GetCategoriesForMenuItemsFilterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoriesForMenuItemsFilterQuery, GetCategoriesForMenuItemsFilterQueryVariables>(GetCategoriesForMenuItemsFilterDocument, options);
      }
export function useGetCategoriesForMenuItemsFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoriesForMenuItemsFilterQuery, GetCategoriesForMenuItemsFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoriesForMenuItemsFilterQuery, GetCategoriesForMenuItemsFilterQueryVariables>(GetCategoriesForMenuItemsFilterDocument, options);
        }
export function useGetCategoriesForMenuItemsFilterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCategoriesForMenuItemsFilterQuery, GetCategoriesForMenuItemsFilterQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCategoriesForMenuItemsFilterQuery, GetCategoriesForMenuItemsFilterQueryVariables>(GetCategoriesForMenuItemsFilterDocument, options);
        }
export type GetCategoriesForMenuItemsFilterQueryHookResult = ReturnType<typeof useGetCategoriesForMenuItemsFilterQuery>;
export type GetCategoriesForMenuItemsFilterLazyQueryHookResult = ReturnType<typeof useGetCategoriesForMenuItemsFilterLazyQuery>;
export type GetCategoriesForMenuItemsFilterSuspenseQueryHookResult = ReturnType<typeof useGetCategoriesForMenuItemsFilterSuspenseQuery>;
export type GetCategoriesForMenuItemsFilterQueryResult = Apollo.QueryResult<GetCategoriesForMenuItemsFilterQuery, GetCategoriesForMenuItemsFilterQueryVariables>;
export const DeleteMenuItemDocument = gql`
    mutation DeleteMenuItem($branchId: Int!, $id: Int!) {
  deleteMenuItem(branchId: $branchId, id: $id)
}
    `;
export type DeleteMenuItemMutationFn = Apollo.MutationFunction<DeleteMenuItemMutation, DeleteMenuItemMutationVariables>;

/**
 * __useDeleteMenuItemMutation__
 *
 * To run a mutation, you first call `useDeleteMenuItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMenuItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMenuItemMutation, { data, loading, error }] = useDeleteMenuItemMutation({
 *   variables: {
 *      branchId: // value for 'branchId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMenuItemMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMenuItemMutation, DeleteMenuItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMenuItemMutation, DeleteMenuItemMutationVariables>(DeleteMenuItemDocument, options);
      }
export type DeleteMenuItemMutationHookResult = ReturnType<typeof useDeleteMenuItemMutation>;
export type DeleteMenuItemMutationResult = Apollo.MutationResult<DeleteMenuItemMutation>;
export type DeleteMenuItemMutationOptions = Apollo.BaseMutationOptions<DeleteMenuItemMutation, DeleteMenuItemMutationVariables>;
export const RestoreMenuItemDocument = gql`
    mutation RestoreMenuItem($branchId: Int!, $id: Int!) {
  restoreMenuItem(branchId: $branchId, id: $id)
}
    `;
export type RestoreMenuItemMutationFn = Apollo.MutationFunction<RestoreMenuItemMutation, RestoreMenuItemMutationVariables>;

/**
 * __useRestoreMenuItemMutation__
 *
 * To run a mutation, you first call `useRestoreMenuItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreMenuItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreMenuItemMutation, { data, loading, error }] = useRestoreMenuItemMutation({
 *   variables: {
 *      branchId: // value for 'branchId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreMenuItemMutation(baseOptions?: Apollo.MutationHookOptions<RestoreMenuItemMutation, RestoreMenuItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreMenuItemMutation, RestoreMenuItemMutationVariables>(RestoreMenuItemDocument, options);
      }
export type RestoreMenuItemMutationHookResult = ReturnType<typeof useRestoreMenuItemMutation>;
export type RestoreMenuItemMutationResult = Apollo.MutationResult<RestoreMenuItemMutation>;
export type RestoreMenuItemMutationOptions = Apollo.BaseMutationOptions<RestoreMenuItemMutation, RestoreMenuItemMutationVariables>;
export type GetMenuItemQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  menuItem?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  locale?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetMenuItemQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', id: number, company?: { __typename?: 'CompanyProxy', id: number, menuItems?: { __typename?: 'MenuItemPaginated', items?: Array<{ __typename?: 'MenuItemProxy', id: number, name?: string | null, nameOrigin?: string | null, types?: Array<{ __typename?: 'MenuTypeProxy', id: number, name: string, slug: string }> | null, categories?: Array<{ __typename?: 'MenuCategoryProxy', id: number, name?: string | null, nameOrigin?: string | null, deleted: boolean }> | null, unit: { __typename?: 'UnitProxy', id: number, name: string }, portions?: Array<{ __typename?: 'MenuItemPortionProxy', id: number, name?: string | null, nameOrigin?: string | null, volume: number, price: number }> | null }> | null } | null } | null } | null };

export type GetCategoriesForMenuItemsFilterQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  locale?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetCategoriesForMenuItemsFilterQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', company?: { __typename?: 'CompanyProxy', meMenuCategories?: Array<{ __typename?: 'MenuCategoryProxy', id: number, name?: string | null, nameOrigin?: string | null, childCategories?: Array<{ __typename?: 'MenuCategoryProxy', id: number, name?: string | null, nameOrigin?: string | null }> | null }> | null } | null } | null };

export type DeleteMenuItemMutationVariables = Types.Exact<{
  branchId: Types.Scalars['Int']['input'];
  id: Types.Scalars['Int']['input'];
}>;


export type DeleteMenuItemMutation = { __typename?: 'Mutation', deleteMenuItem: boolean };

export type RestoreMenuItemMutationVariables = Types.Exact<{
  branchId: Types.Scalars['Int']['input'];
  id: Types.Scalars['Int']['input'];
}>;


export type RestoreMenuItemMutation = { __typename?: 'Mutation', restoreMenuItem: boolean };
